import classNames from "classnames";

const Button = ({
  children,
  type = "default",
  onClick,
  htmlType = "button",
  ...rest
}: any) => {
  return (
    <button
      type={htmlType}
      onClick={onClick}
      className={classNames(
        `flex items-center justify-center gap-1 text-sm font-bold px-[15px] py-[8px] whitespace-nowrap transition-all ${rest.className}`,
        {
          "bg-primaryred text-white border border-solid border-primaryred rounded-[8px] hover:bg-red-600 hover:border-red-600":
            type === "primary",
          "bg-white text-primaryred border border-solid border-primaryred rounded-[8px] hover:bg-red-100 hover:text-primaryred":
            type === "secondary",
          "bg-[#221122] text-white border border-solid border-[#221122] rounded-[8px] hover:bg-[#333] hover:border-[#333]":
            type === "navy",
          "bg-white text-gray-800 border border-solid border-gray-300 rounded-[8px] hover:bg-gray-100":
            type === "action",
          "bg-white text-gray-800 border border-solid border-darknavy rounded-[8px] hover:bg-darknavy hover:text-white rounded-full":
            type === "default",
          "bg-gray-800 text-white border border-solid border-darknavy rounded-[8px] hover:bg-white hover:text-darknavy rounded-full":
            type === "black",
          "bg-blue-400 text-white border border-solid border-blue-400 rounded-[8px] hover:bg-white hover:text-blue-400 rounded-lg":
            type === "blue",
          "bg-transparent text-darknavy border border-solid border-darknavy rounded-[8px] hover:bg-white hover:text-darknavy rounded-full":
            type === "transparent",
          "bg-primaryred text-white border border-solid border-primaryred rounded-r-[8px] hover:bg-red-600 hover:border-red-600":
            type === "filterSearch",
          "bg-[#EDF2F7] text-[#4A5568] border border-solid border-[#EDF2F7] rounded-[8px] hover:text-darknavy hover:border-gray-300 rounded-full":
            type === "gray",
        }
      )}
    >
      {children}
    </button>
  );
};

export default Button;
